module.exports = __webpack_public_path__ + "28b67065/img/settings-icon.121d9519.svg";